// utils/authFlags.js
import secureLocalStorage from "react-secure-storage";

export const setPartnerVerifiedFlag = (value) => {
  const v = !!value;

  // keep ONE canonical value in localStorage for Sidebar
  localStorage.setItem("partnerVerified", v ? "1" : "0");

  // optional: also store in secure storage
  secureLocalStorage.setItem("partnerVerified", v);

  // notify same-tab React components (storage event won't fire in same tab)
  window.dispatchEvent(new Event("authUpdate"));
};

export const readPartnerVerifiedFlag = () => {
  let raw = localStorage.getItem("partnerVerified");

  if (raw == null || raw === "") raw = secureLocalStorage.getItem("partnerVerified");
  if (raw == null || raw === "") return false;

  if (typeof raw === "boolean") return raw;

  if (raw === "1") return true;
  if (raw === "0") return false;

  const s = String(raw).trim().toLowerCase();
  if (s === "true") return true;
  if (s === "false") return false;

  try {
    return JSON.parse(raw) === true;
  } catch {
    return false;
  }
};